import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    batchEntries: [],
    quarantineStatus: false,
    batchTypes: {},
    batchInfo: [],
    parentBatchInfo: [],
    batchUpdate: [],
    // Batch status
    batchTypesForStatus: [],
    batchStatus: [],
    batchStatuses: []
};

const getters = {
    getBatchEntries: (state) => state.batchEntries,
    getQuarantineStatus: (state) => state.quarantineStatus,
    getBatchTypes: (state) => state.batchTypes,
    getBatchInfo: (state) => state.batchInfo,
    getParentBatchInfo: (state) => state.parentBatchInfo,
    // Batch status
    getBatchTypesForStatus: (state) => state.batchTypesForStatus,
    getBatchStatus: (state) => state.batchStatus,
    getBatchStatuses: (state) => state.batchStatuses
};

const actions = {
    async getQuarantineStatus( context, data ) {
        await axios.post(`${backendUrl()}/getQuarantineStatus`, null,
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setQuarantineStatus', response.data)
        })
    },
    async getBatchEntries( context, data ) {
        await axios.post(`${backendUrl()}/getBatchEntries`,
        {
            userId: context.getters.getUserDetails.id,
            userEmail: context.getters.getUserDetails.email,
            userLevel: context.getters.getUserLevel
        },
        {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') },
            params: {
                page: data.page,
                per_page: data.per_page,
                batch_ref: data.batch_ref,
                batch_id: data.batch_id,
                upload_after: data.upload_after,
                upload_before: data.upload_before,
                batch_type: data.batch_type,
                batch_status: data.batch_status,
                sub_batch_name: data.sub_batch_name,
                invoice_from: data.invoice_from,
                invoice_to: data.invoice_to,
                invoice_number: data.invoice_number,
                customer_number: data.customer_number,
                append_after_action: data.append_after_action,
                expand_all: data.expand_all,
                expanded: data.expanded,
            }
        })
        .then(response => {
            if(data.append_results && state.batchEntries && typeof state.batchEntries === 'object' && state.batchEntries.data) {
                let currentBatches = state.batchEntries.data
                let batchesCollection = currentBatches.concat(response.data.data)
                response.data.data = batchesCollection
                context.commit('setBatchEntries', response.data)
            } else {
                context.commit('setBatchEntries', response.data)
            }
        })
    },
    async getParentBatch( context, data ) {
        return await axios.post(`${backendUrl()}/getBatchEntries`,
            {
                userId: context.getters.getUserDetails.id,
                userEmail: context.getters.getUserDetails.email,
                userLevel: context.getters.getUserLevel
            },
            {
                headers: { 'Authorization': "bearer " +  vuecookie.get('token') },
                params: {
                    batch_id: data.batch_id,
                    batch_ref: data.batch_ref,
                    upload_after: data.upload_after,
                    upload_before: data.upload_before,
                    batch_type: data.batch_type,
                    batch_status: data.batch_status,
                    sub_batch_name: data.sub_batch_name,
                    invoice_from: data.invoice_from,
                    invoice_to: data.invoice_to,
                    invoice_number: data.invoice_number,
                    customer_number: data.customer_number,
                }
            })
            .then(response => {
                return response.data
            })
    },
    async getBatchTypes(context) {
        await axios.post(`${backendUrl()}/getBatchTypes`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchTypes', response.data)
        })
    },
    async getBatchTypesForStatus(context) {
        await axios.post(`${backendUrl()}/getBatchTypesForStatus`, null,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchTypesForStatus', response.data)
        })
    },
    async getBatchInfo(context, data) {
        await axios.post(`${backendUrl()}/getBatchInfo`,
        {
            batchId: data.batchId,
            parentBatchId: data.parentBatchId,
            userId: data.userId
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setBatchInfo', response.data)
        })
    },
    async updateBatchDeliveryMode(context, data) {
        await axios.post(`${backendUrl()}/updateBatchDeliveryMode`,
        {
            batchId: data.batchId,
            deliveryMode: data.deliveryMode,
            testMode: data.testMode,
            userLevel: data.userLevel,
            userId: context.getters.getUserDetails.id,
            clientId: context.getters.allTemplateDetails.id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async deleteBatch(context, data) {
        await axios.post(`${backendUrl()}/deleteBatch`,
        {
            batchId: data.batchId,
            batchType: data.batchType,
            userLevel: context.getters.getUserLevel,
            userId: context.getters.getUserDetails.id,
            clientId: context.getters.allTemplateDetails.id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async deleteAllTestBatches(context, data) {
        await axios.post(`${backendUrl()}/deleteAllTestBatches`,
        {
            userLevel: context.getters.getUserLevel,
            clientId: context.getters.allTemplateDetails.id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async cancelBatch(context, data) {
        await axios.post(`${backendUrl()}/cancelBatch`,
        {
            batchId: data.batchId,
            userLevel: context.getters.getUserLevel
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async cancelBatchReminders(context, data) {
        await axios.post(`${backendUrl()}/cancelBatchReminders`,
        {
            batchId: data.batchId,
            userLevel: context.getters.getUserLevel
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },
    async getBatchStatus(context, data) {
        await axios.post(`${backendUrl()}/getBatchStatus`,
        {
            userLevel: context.getters.getUserLevel,
            clientId: context.getters.allTemplateDetails.id,
            userEmail: context.getters.getUserDetails.email,
            userId: context.getters.getUserDetails.id
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') },
            params: {
                page: data.page,
                per_page: data.per_page,
                batch_id: data.batch_id,
                batch_ref: data.batch_ref,
                batch_type: data.batch_type,
                batch_status: data.batch_status,
                upload_after: data.upload_after,
                upload_before: data.upload_before
            }
        })
        .then(response => {
            context.commit('setBatchStatus', response.data)
        })
    },
    async getBatchStatuses(context) {
      await axios.post(`${backendUrl()}/getBatchStatuses`, null,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setBatchStatuses', response.data)
      })
    },


    async downloadBatchData(context, data) {
        return await axios.get(`${backendUrl()}/downloadBatchData/` + data.id + '/' + data.token,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async exportControlFile(context, data) {
      return await axios.post(`${backendUrl()}/exportControlFile`, data,
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          return response.data
      })
    },

    async checkBatchData(context, data) {
        return await axios.post(`${backendUrl()}/checkBatchData`, data,
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            return response.data
        })
      }
};

const mutations = {
  setBatchEntries:(state, batchEntries) => (state.batchEntries = batchEntries),
  setQuarantineStatus: (state, quarantineStatus) => (state.quarantineStatus = quarantineStatus),
  setBatchTypes:(state, batchTypes) => (state.batchTypes = batchTypes),
  setBatchInfo: (state, batchInfo) => (state.batchInfo = batchInfo),
  setParentBatchInfo: (state, parentBatchInfo) => (state.parentBatchInfo = parentBatchInfo),
  // Batch status
  setBatchTypesForStatus: (state, batchTypes) => (state.batchTypesForStatus = batchTypes),
  setBatchStatus: (state, batchStatus) => (state.batchStatus = batchStatus),
  setBatchStatuses: (state, batchStatuses) => (state.batchStatuses = batchStatuses)
};

export default {
    //namespaced: true,
    state,
    getters,
    actions,
    mutations
}
